import { Typography } from "antd";
import React from "react";
import { Col, Row, Table } from "react-bootstrap";
import { numberFormater } from "../../utils";
import PropTypes from "prop-types";

const { Text } = Typography;

// reportType
const BillingReportBody = ({ reportValues = {} }) => {
  return (
    <div className="p-4">
      <Row xs={1} md={2}>
        {/* Report Information */}
        <Col>
          <h5 className="mb-4 fw-bold">Report Information</h5>
          {reportFields.map((field, index) => (
            <Row key={index} xs={1} md={2} className="align-items-center">
              <Col className="my-2 flex justify-between">
                <Text>{field.label}</Text>
              </Col>
              <Col className="my-2 flex justify-between">
                <p className="bg-gray-300 px-2 py-1 w-100 rounded-2 mb-0" style={{ minHeight: 30 }}>
                  {reportValues[field?.value] || ""}
                </p>
              </Col>
            </Row>
          ))}
        </Col>

        {/* Electricity Usage Information */}
        <Col>
        <h5 className="mb-4 fw-bold">Electricity Usage Information</h5>
          {/* <label className="az-content-label mb-3" style={{ fontSize: 12 }}>
            Electricity Usage Information{" "}
          </label> */}

          <Table bordered responsive className="mt-1">
            <thead className="text-white text-center">
              <tr>
                <th style={{ background: "#f25c4394" }} className="text-black" colSpan={2}>
                  Electricity Cost Breakdown
                </th>
              </tr>
            </thead>
            <tbody>
              {(electricityData(reportValues?.reportType, reportValues?.type) || [])?.map((item, index) => (
                <tr key={index} className={`${item?.bold ? "fw-bold" : ""}`}>
                  <td className="px-3 "> {item?.name} </td>
                  <td className="px-3 text-end">{numberFormater(reportValues[item?.value]) || "0.00"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  );
};

export default BillingReportBody;

BillingReportBody.propTypes = {
  reportValues: PropTypes.object,
};

const reportFields = [
  { label: "Report Generation Date", value: "reportGenerationDate" },
  { label: "Monthly Cycle Selected", value: "monthlyCycleSelected" },
  { label: "Site Name", value: "site" },
  { label: "Site Address", value: "siteAddress1" },
  { label: "", value: "siteAddress2" },
  { label: "Meter ID", value: "device" },
  { label: "Installed Area", value: "installedArea" },
];

const electricityData = (reportType, tax) => {
  let electricityData = [
    { name: "Maximum Demand (RM)", value: "demandTotalPrice" },
    { name: `Service Tax (${tax ?? "0"}%) `, value: "serviceTax" },
    { name: "Total Charge (RM)", value: "totalCharge", bold: true },
  ];
  if (reportType === "type1") {
    electricityData = [
      { name: "Peak Usage This Month (RM)", value: "peakHourElectricityPrice" },
      { name: "Off Peak Usage This Month (RM)", value: "offPeakHourElectricityPrice" },
      ...electricityData,
    ];
  } else if (reportType === "type2") {
    electricityData = [{ name: "All Usages This Month (RM)", value: "totalElectricityPrice" }, ...electricityData];
  }
  return electricityData;
};
